import { ComponentChild, h } from 'preact'
import Panel from '../panel'

const StatisticsBar = ({ switcher, dragHandle }: {switcher: ComponentChild, dragHandle: ComponentChild}) => {
  return (
    <Panel
      class='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            { dragHandle }
            <span>Statistics bar</span>
          </div>
          { switcher }
        </div>
      } />
  )
}

export default StatisticsBar
